document.getElementById('search-location').addEventListener('keypress', function (e) {
  if (e.key === 'Enter') {
    seachLocation()
  }
});

//--Initiate the map
function initMap() {
  const mapElem = document.getElementById('map');
  const params = new URLSearchParams(window.location.search)
  const startPoint = {
      lat: parseFloat(params.get('lat')) || 41.89269371477544,
      lng: parseFloat(params.get('lng')) || -87.63413064308826,
    }
  map = new google.maps.Map(mapElem, {
    center: startPoint,
    zoom: 12,
  });
}

//--Search by current location
function getMyLocation() {
  navigator.geolocation.getCurrentPosition(
    (geolocation) => {
      const { latitude, longitude } = geolocation.coords;
      if (map) {
        map.setCenter({
          lng: longitude,
          lat: latitude,
        });
      }
      getStores(null, latitude, longitude);
    },
    () => null,
    { timeout: 10000 },
  );
}

//--Search by location field
function seachLocation() {
  let address =  document.getElementById('search-location').value;
  fetch("https://maps.googleapis.com/maps/api/geocode/json?address="+address+'&key=AIzaSyBnRZ-MQhVOj8sogv3q8PEh2Ko56HJV2P4')
  .then(response => response.json())
  .then(data => {
    const latitude = data.results[0].geometry.location.lat;
    const longitude = data.results[0].geometry.location.lng;
    const location = {lat: latitude, lng: longitude};
    map.setCenter(location)
  });
  getStores(address);
}

//--Mark the stores on the map
function markStore(storeInfo){
  let coordiantes = {
      lat: storeInfo.coordinates[1],
      lng: storeInfo.coordinates[0]
  }
  const storeHTML = `
    <div class="border-b border-secondaryLight py-4 cursor-pointer" data-location="${coordiantes.lat},${coordiantes.lng}">
      <h4 class="text-lg uppercase p-0 mb-2">${storeInfo.name}</h4>
      <p class="text-small opacity-50">${storeInfo.address1}${storeInfo.address2 ? ` ${storeInfo.address2}` : ''}, ${storeInfo.city} ${storeInfo.state}, ${storeInfo.zipCode}</p>
      ${storeInfo.phoneNumber ? `<p class="text-small opacity-50">${storeInfo.phoneNumber}</p>` : ''}
    </div>`;
  const results = document.getElementById('results');
  results.insertAdjacentHTML('beforeend', storeHTML);
  document.getElementById('search-now').style.display = 'none';
  var marker = new google.maps.Marker({
    map: map,
    position: coordiantes,
    title: storeInfo.name
  });
  if (window.innerWidth < 768) {
    document.querySelector('#map').style.display = 'none';
    document.querySelector('#ghost-energy').style.display = 'block';
  }
}

//--Get the list of stores
function getStores(address, lat, lng) {
  const shop = "ghost-lifestyle.myshopify.com";
  let searchRadius = document.getElementById('search-radius').value;
  let params = 'distance='+searchRadius;
  if (address != null) {
    params += '&address='+address;
  } else if (lat && lng) {
    params += '&lng='+lng+'&lat='+lat;
  } else {
    return;
  }
  params += '&shop=' + shop;
  fetch('https://x51gcqm7da.execute-api.us-east-1.amazonaws.com/production/api/stores?'+params)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      let storeData = data.stores;
      document.querySelectorAll('#results div').forEach( item => {
        item.remove();
      });
      storeData.forEach(store => {
        markStore(store);
      });
      document.querySelectorAll('#results div').forEach( item => {
        item.addEventListener('click', (e) => {
          let coordinates = item.getAttribute("data-location").split(','),
              latitude = parseFloat(coordinates[0]),
              longitude = parseFloat(coordinates[1]),
              location = {lat: latitude, lng: longitude};
          map.panTo(location);
          map.setZoom(16);
          document.querySelectorAll('#results div').forEach( item => {
            item.classList.remove('border-b-2', 'border-primaryDark');
          });
          item.classList.add('border-b-2', 'border-primaryDark');
          if (window.innerWidth < 768) {
            document.querySelectorAll('#results div').forEach( item => {
              item.style.display = 'none';
            });
            document.querySelector('#ghost-energy').style.display = 'none';
            item.style.display = 'block';
            let mapDiv = document.querySelector('#map');
            mapDiv.style.display = 'block';
            mapDiv.style.height = "485px"
          }
        })
      })
      if (searchRadius == "10") map.setZoom(12);
      else if (searchRadius == "25") map.setZoom(10);
      else if (searchRadius == "50") map.setZoom(9);
      else map.setZoom(8);
    }
  )
}
